/**
 * La barre d'attente, une seule pour toute l'application.
 *
 * Montée une fois dans `App`, au-dessus des quatre coquilles — élève, parent,
 * V2, réglages — parce que la demande était *« c'est vrai pour tout le
 * site »* : une barre par écran, ce sont trente-deux endroits où celui écrit
 * demain sera oublié, et c'est la forme que ce dépôt paie depuis une vingtaine
 * d'occurrences.
 *
 * Ce qu'elle montre vient de `api/chargement`, donc de ce qui est réellement
 * en vol vers le serveur : elle ne peut pas s'afficher sans attente, ni
 * manquer une attente.
 *
 * `aria-hidden` : l'annonce est déjà faite par le `role="status"` de `Loading`
 * et par le libellé du bouton pressé. Une barre qui parle en plus ferait dire
 * deux fois la même chose à un lecteur d'écran, dont une fois en pourcentage.
 */

import { useAvancement } from "@/api/chargement";

export function BarreDeChargement() {
  const avancement = useAvancement();
  if (avancement <= 0) return null;

  return (
    <div className="chargement" aria-hidden="true">
      <div className="chargement__part" style={{ width: `${Math.round(avancement * 100)}%` }} />
    </div>
  );
}
